import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import VCharts from 'v-charts';
import JsonExcel from 'vue-json-excel'
import 'element-ui/lib/theme-chalk/index.css';
import './router/gloable.css'
import request from './router/request';

Vue.config.productionTip = false
Vue.use(ElementUI,{size:"small"});
Vue.use(VCharts);
Vue.prototype.request = request;
Vue.component('downloadExcel', JsonExcel);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
